import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const container = css`
  padding: ${spacing.sm}px 0;
  color: var(--neutral-white-base);
  ${responsiveText.BODY.SM};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: grid;
      grid-template-columns: auto 80px;
      grid-template-areas: 'list badge';
    `,
  )};

  a {
    display: inline-block;
    color: inherit;
  }
`;

export const awardBadge = css`
  margin: 0 auto;
  width: 80px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-area: badge;
    `,
  )};

  svg {
    display: block;
  }
`;

export const lists = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-area: list;
      align-self: center;
    `,
  )};
`;

export const list = css`
  margin: ${spacing.sm}px 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  column-gap: ${spacing.sm}px;

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      justify-content: center;
    `,
  )};
`;
